// store/modules/ui.js
export default {
	namespaced: true,
	state: () => ({
		avatarPreview: null,
		avatarSrc: null,
		isUploading: false,
		avatarTimestamp: null,
	}),
	mutations: {
		SET_AVATAR_PREVIEW(state, preview) {
			state.avatarPreview = preview
		},
		CLEAR_AVATAR_PREVIEW(state) {
			if (state.avatarPreview) {
				URL.revokeObjectURL(state.avatarPreview)
				state.avatarPreview = null
			}
		},
		SET_AVATAR_SRC(state, src) {
			state.avatarSrc = src
		},
		SET_IS_UPLOADING(state, status) {
			state.isUploading = status
		},
		SET_AVATAR_TIMESTAMP(state, timestamp) {
			state.avatarTimestamp = timestamp
		},
	},
	actions: {
		updateAvatarPreview({ commit }, file) {
			if (!file || !file.type.match('image.*')) return
			const preview = URL.createObjectURL(file)
			commit('SET_AVATAR_PREVIEW', preview)
		},
		setUploadingStatus({ commit }, status) {
			commit('SET_IS_UPLOADING', status)
		},
		clearAvatarPreview({ commit }) {
			commit('CLEAR_AVATAR_PREVIEW')
		},
		updateAvatarSrc({ commit }, path) {
			const fullUrl =
				path.startsWith('http') || path.startsWith('data:')
					? path
					: path.startsWith('/') ? path : `/${path}`
			commit('SET_AVATAR_SRC', fullUrl)
			commit('SET_AVATAR_TIMESTAMP', Date.now())
		},
		initAvatarSrcFromUser({ commit, rootGetters }) {
			const user = rootGetters['auth/user']
			if (user && user.avatar) {
				commit('SET_AVATAR_SRC', user.avatar)
				commit('SET_AVATAR_TIMESTAMP', Date.now())
			} else {
				commit('SET_AVATAR_SRC', null)
				commit('SET_AVATAR_TIMESTAMP', null)
			}
		},
	},
	getters: {
		avatarSrc(state, _, __, rootGetters) {
			if (state.avatarPreview) return state.avatarPreview

			if (state.avatarSrc)
				return `${state.avatarSrc}?t=${state.avatarTimestamp || ''}`

			const user = rootGetters['auth/user']
			if (user?.avatar) {
				return `${user.avatar}?t=${state.avatarTimestamp || ''}`
			}
			return require('@/assets/images/header/avatar.jpg')
		},

		avatarPreview: state => state.avatarPreview,
		isUploading: state => state.isUploading,
	},
}
